import React from 'react'
import ReactDOM from 'react-dom'
import { RecoilRoot } from 'recoil'
import { Spin } from 'antd'

import { DebugObserver } from './utils/DebugObserver'
import App from './App'

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      {process.env.REACT_APP_ENV &&
      ['dev', 'staging'].includes(process.env.REACT_APP_ENV) ? (
        <DebugObserver />
      ) : null}
      <React.Suspense
        fallback={
          <Spin
            spinning={true}
            className="default-layout__spinner"
            tip={'loading'}
          />
        }
      >
        <App />
      </React.Suspense>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
)
